import React from 'react';
import { Field } from 'formik';

import FormInput from 'components/common/forms/elements/FormInput';

const RadioInput = ({label, name, options, ...props}) => {
  return <div role="group" style={{marginBottom: 15}}>
    <Field name={name} >
      {
        ({ field }) => {
          return options.map((option, index) => {
            return <FormInput
              key={index}
              type="radio" 
              id={option.id || `${name}-${index}`}
              name={name} 
              label={option.label}
              {...props}
              checked={field.value === option.value}
              value={option.value}
              />
          })
        }
      }
    </Field>    
  </div>
}

export default RadioInput